import { render, staticRenderFns } from "./InviteStaffDialog.vue?vue&type=template&id=26d81c6b&"
import script from "./InviteStaffDialog.vue?vue&type=script&lang=ts&"
export * from "./InviteStaffDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports